<template>
    <v-tab-item eager>
        <v-card
            color="grey lighten-3"
            flat
        >
            <v-card-text>

                <v-text-field
                    v-model="internalValue"
                    :label="$t('Text Filter Value')"
                    autofocus
                    clearable
                    hide-details
                    prepend-inner-icon="mdi-search"
                ></v-text-field>

            </v-card-text>
        </v-card>
    </v-tab-item>
</template>
<script>
export default {
        name: 'StringFilterItem',
        props: {
            value: {
                type: [String],
                default: ''
            },
            resourceName: String
        },

        data() {
            return {
                internalValue: this.value,
                pending:       false,
                showLoading:   false,
                emitTimeout:   null,
            };
        },

        watch: {
            // update internal value based on external changes
            value(newValue) {
                this.internalValue = newValue || ''
            },

            // emit event when internal filters are changed
            internalValue(newInternalValue) {
                if (this.emitTimeout) {
                    clearTimeout(this.emitTimeout);
                }
                this.emitTimeout = setTimeout(() => {
                    this.$emit('input', newInternalValue || '')
                }, 1000);
            },
        },

        methods: {



            deselect() {
                this.internalValue = '';
            },

            deselectAll() {
                this.internalValue = '';
            },

            selectAllFiltered() {

            },

            toggleSelect() {

            },

            selectFilteredValue() {

            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../../node_modules/vuetify/src/components/VCard/variables";
    @import "../../../../node_modules/vuetify/src/components/VChip/variables";

    .row {
        flex-wrap: nowrap;
        overflow: auto;
    }

    .grid {
        display: grid;
        grid-template-rows: repeat(6, calc(#{$card-text-font-size} + 1.5rem));
        grid-auto-flow: column;
        justify-content: start;
        overflow-x: auto;
    }

    .grid label {
        white-space: nowrap;
        margin-right: 1rem;
        margin-bottom: 0.5rem;
    }

    .grid label input:focus + span {
        color: var(--main-header);
        text-shadow: 0px 0px 6px var(--table-no-data-color);
    }

    .v-item-group {
        min-height: 3rem;
    }

    div.magnify i {
        background-color: var(--main-header);
        border-radius: 100px;
        padding: 16px;
    }
    div.magnify {
        margin-top: 6px;
    }
    div.filter-description p {
        margin-bottom: 0;
    }
    div.v-card__subtitle {
        display: flex;
        gap: 16px;
        padding-bottom: 0;
    }
    div.v-input.filter-checkboxes {
        margin-top: 0 !important;
    }

    [type="checkbox"] + span {
        padding-right: 8px;
    }
    [type="checkbox"] {
        position: relative;
        left: 15px;
        top: -4px;
        z-index: 0;
        -webkit-appearance: none;
    }
    [type="checkbox"] + span::before {
        width: 24px;
        height: 24px;
        background-image: url("../../../assets/icons/check_box_unchecked.svg");
        background-size: 24px;
        display: block;
        content: "";
        float: left;
        z-index: 5;
        position: relative;
        margin-right: -6px;
    }
    [type="checkbox"]:checked+span::before {
        background-image: url("../../../assets/icons/check_box_checked.svg");
    }
</style>
